import { Fragment } from 'react'

import { EMPTY_FUNCTION, EMPTY_LIST } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_24, BUTTON_HEIGHT_32 } from '../../Button'
import { Divider } from '../../Divider'
import { FloatingSelectDropdown } from '../../Floating'
import { SelectDropdown } from '../../Select'

import { useGretaAIChatRowMenu } from './GretaAIChatRowMenu.hooks'
import { getHasGretaAIChatRowMenuDivider } from './GretaAIChatRowMenu.utils'

import * as styles from './GretaAIChatRowMenu.module.css'

import MoreHorizontalIcon from '../../../icons/more-horizontal.svg'

function GretaAIChatRowMenu({
  buttonHeight = BUTTON_HEIGHT_24,
  className,
  items = EMPTY_LIST,
  qaName,
  onOpenChange = EMPTY_FUNCTION,
}) {
  const {
    context,
    floatingStyles,
    getFloatingProps,
    getHandleClickItem,
    handleToggle,
    isOpen,
    refs,
  } = useGretaAIChatRowMenu({ onOpenChange })

  const { setReference } = refs

  return (
    <>
      <Button.Icon
        isGrey
        Icon={MoreHorizontalIcon}
        beforeIconProps={{ height: BUTTON_HEIGHT_24 }}
        className={className}
        elementRef={setReference}
        height={buttonHeight}
        qaName={qaName}
        onClick={handleToggle}
      />
      <FloatingSelectDropdown
        context={context}
        floatingStyles={floatingStyles}
        getFloatingProps={getFloatingProps}
        isOpen={isOpen}
        refs={refs}
      >
        <SelectDropdown className={styles.menu}>
          {items.map((item, index) => {
            const { Icon, qaName: itemQaName, text } = item
            const hasDivider = getHasGretaAIChatRowMenuDivider(index)

            return (
              <Fragment key={itemQaName}>
                {hasDivider ? <Divider /> : null}
                <Button.Flat
                  isGrey
                  beforeIconProps={{
                    Icon,
                    iconProps: { className: styles.itemIcon },
                  }}
                  className={styles.item}
                  height={BUTTON_HEIGHT_32}
                  qaName={itemQaName}
                  text={text}
                  textClassName={styles.itemLabel}
                  onClick={getHandleClickItem(item)}
                />
              </Fragment>
            )
          })}
        </SelectDropdown>
      </FloatingSelectDropdown>
    </>
  )
}

export default GretaAIChatRowMenu
